import { Fragment } from 'react';

import { Logger } from 'lib/logger';

import { resetFailedModuleConfirmVisibility } from '../cookie';

const DYNAMIC_IMPORT_ATTEMPTS = 3;

const handleModuleLoadFailure = (
  confirmationText: string,
  warnMessage: string,
  error: unknown,
): typeof Fragment => {
  if (process.env.NEXT_PUBLIC_CONFIRM_ON_MODULES_FAIL !== 'true') {
    Logger.warn({ message: warnMessage, error });

    return Fragment;
  }

  const countOfReloadAttemptsVisibleForUser = resetFailedModuleConfirmVisibility();

  if (countOfReloadAttemptsVisibleForUser > 1) {
    return Fragment;
  }

  const isWilling = window.confirm(confirmationText);

  if (isWilling) {
    window.location.reload();
  } else {
    Logger.warn({ message: warnMessage, error });
  }

  return Fragment;
};

export const importModuleWithRetries = <T>(importFn: () => Promise<T>): Promise<T> => {
  let chain = importFn();

  for (let i = 1; i < DYNAMIC_IMPORT_ATTEMPTS; i += 1) {
    chain = chain.catch(() => importFn());
  }

  return chain;
};

export async function dynamicImportWithRetries<T>(
  importFn: () => Promise<T>,
  confirmationText: string,
  warnMessage: string,
) {
  try {
    return await importModuleWithRetries(importFn);
  } catch (e) {
    return handleModuleLoadFailure(confirmationText, warnMessage, e);
  }
}

export const notifyModuleLoadFailure = (
  confirmationText: string,
  warnMessage: string,
  error: unknown,
): void => {
  handleModuleLoadFailure(confirmationText, warnMessage, error);
};
